export const datasets = {
  il_dualcredit_entity: "il-dualcredit-entity",
};

export const toolkits = {
  il_dualcredit_toolkit: "il-dualcredit-toolkit",
};
